// projects/wp-shared/orchestrator/main.js

// Importa tus componentes/librerías en el orden que necesites
import '../js/animations.js';
import '../js/carousel.js';
import '../js/dialog.js';
import '../js/drawer.js';
import '../js/header.js';
import '../js/cookie-consent.js';
import '../js/scroll-bar-items.js';
import '../js/search.js';
import '../js/spinner.js';
import '../js/toast.js';
import '../js/theme-toggle.js';

// Importar JS del plugin
import '../../../wp-content/plugins/portfolio-settings/assets/js/home-carousel.js';
import '../../../wp-content/plugins/portfolio-settings/assets/js/content-library-feed.js';

// Si tus archivos exportan funciones, puedes usarlas aquí,
// pero si solo quieres ejecutar código (efecto secundario), con el import basta.
// console.log('Bundle JS cargado correctamente');
console.log('Orchestrator is running');

// Inicializa los iconos de Lucide después de que el DOM esté listo (previamente cargados en enqueue-assets)
document.addEventListener("DOMContentLoaded", () => {
    // Verificamos si la librería cargó correctamente
    if (window.lucide) {
        window.lucide.createIcons();
        // console.log('Iconos Lucide inicializados');
    } else {
        console.warn('Lucide no se ha cargado correctamente');
    }
});